import { useRef } from 'react'
import { useRouter } from 'next/navigation'
import { useTheme } from 'next-themes'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'
import { useRipple } from '@/hooks/useRipple'

const MainButton = () => {
  const { currentScreen } = useDeliveryAppContext()
  const router = useRouter()

  const ref = useRef(null)
  useRipple(ref, 'rgb(169, 174, 179, 0.3)')

  const { resolvedTheme } = useTheme()

  const handleClick = () => {
    router.push('/')
  }

  return (
    <button
      ref={ref}
      className="relative w-12 h-12 p-[9px] overflow-hidden rounded-full"
      onClick={handleClick}
    >
      {currentScreen === 'main' ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          fill={resolvedTheme === 'dark' ? '#e0e0e0' : '#323e48'}
        >
          <path d="M240 320h320c26.4 0 48-21.6 48-48v-192C608 53.6 586.4 32 560 32H448v128l-48-32L352 160V32H240C213.6 32 192 53.6 192 80v192C192 298.4 213.6 320 240 320zM608 384H128V64c0-35.2-28.8-64-64-64H31.1C14.4 0 0 14.4 0 32S14.4 64 31.1 64H48C56.84 64 64 71.16 64 80v335.1c0 17.6 14.4 32 32 32l66.92-.0009C161.1 453 160 458.4 160 464C160 490.5 181.5 512 208 512S256 490.5 256 464c0-5.641-1.13-10.97-2.917-16h197.9c-1.787 5.027-2.928 10.36-2.928 16C448 490.5 469.5 512 496 512c26.51 0 48.01-21.49 48.01-47.1c0-5.641-1.12-10.97-2.907-16l66.88 .0009C625.6 448 640 433.6 640 415.1C640 398.4 625.6 384 608 384z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          fill="#6b7280"
        >
          <path d="M616 399.1H144V64c0-35.2-28.8-64-64-64H24C10.8 0 0 10.8 0 23.1c0 13.2 10.8 23.1 24 23.1h48c13.25 0 24 10.75 24 24v343.1c0 17.6 14.4 31.1 31.1 31.1l34.92 .0023C161.1 453 160 458.4 160 464C160 490.5 181.5 512 208 512S256 490.5 256 464c0-5.643-1.128-10.97-2.917-16h197.9c-1.789 5.029-2.928 10.36-2.928 16C448 490.5 469.5 512 496 512c26.51 0 48.01-21.49 48.01-47.1c0-5.643-1.118-10.97-2.907-16L616 447.1c13.2 0 24-10.8 24-23.1C640 410.8 629.2 399.1 616 399.1zM256 352h288c35.35 0 64-28.66 64-64V96c0-35.35-28.65-63.1-64-63.1H256c-35.35 0-64 28.65-64 63.1v191.1C192 323.3 220.7 352 256 352zM240 96C240 87.18 247.2 80 256 80l80-.0016v111.1l64-31.1l64 31.1V80L544 80c8.822 0 16 7.178 16 15.1v191.1c0 8.822-7.178 15.1-16 15.1H256c-8.822 0-16-7.178-16-15.1V96z" />
        </svg>
      )}
    </button>
  )
}

export default MainButton
